import React, { useState } from 'react';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import axios from 'axios';
import { Icon } from "@iconify/react";
import { useConfig } from "../utils/ConfigContext.jsx";
import { createAxiosInstance } from "../utils/AxiosInstance.jsx";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { SetUserData } from '../utils/redux/slices/authSlice.jsx';

const ChangePassword = () => {
  const { API_BASE_URL } = useConfig();
  const AxiosInstance = createAxiosInstance(API_BASE_URL);

  const userData = useSelector((state) => state.auth.userData);
  const dispatch = useDispatch();
  

  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    logoutAllDevices: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.currentPassword) {
      newErrors.currentPassword = 'Current password is required';
    }

    if (!formData.newPassword) {
      newErrors.newPassword = 'New password is required';
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = 'New password must be at least 6 characters';
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your new password';
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');

    if (!validateForm()) return;

    try {
      setLoading(true);

      const response = await AxiosInstance.post('/change-password', {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        logoutAllDevices: formData.logoutAllDevices,
      });

      setSuccessMessage(response.data.message || 'Password changed successfully');

      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        logoutAllDevices: true,
      });

      setErrors({});
      dispatch(SetUserData({ ...userData, must_change_password: 0 }));
    } catch (error) {
      if (error.response?.data?.errors) {
        const apiErrors = {};
        Object.keys(error.response.data.errors).forEach(key => {
          apiErrors[key.replace('_', '')] = error.response.data.errors[key][0];
        });
        setErrors(apiErrors);
      } else {
        setErrors({
          submit: error.response?.data?.message || 'Failed to change password',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Change Password" />

      <div className="container pb-5 mb-5">
        <div className="row justify-content-center">
          <div className="col-md-6">

            {successMessage && (
              <div className="alert alert-success alert-dismissible fade show">
                {successMessage}
                <button className="btn-close" onClick={() => setSuccessMessage('')} />
              </div>
            )}

            {errors.submit && (
              <div className="alert alert-danger alert-dismissible fade show">
                {errors.submit}
                <button className="btn-close" onClick={() => setErrors({})} />
              </div>
            )}

            <form onSubmit={handleSubmit} noValidate>

              <div className="mb-3">
                <label className="form-label">Current Password</label>
                <div className="position-relative">
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    name="currentPassword"
                    autoComplete="current-password"
                    className={`form-control ${errors.currentPassword ? 'is-invalid' : ''}`}
                    value={formData.currentPassword}
                    onChange={handleChange}
                  />
                  <span
                    className="position-absolute top-50 translate-middle-y cursor-pointer"
                    style={{ right: "12px" }}
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  >
                    <Icon
                      icon={showCurrentPassword ? "mage:eye" : "mage:eye-off"}
                    />
                  </span>
                </div>
                {errors.currentPassword && <div className="invalid-feedback d-block">{errors.currentPassword}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label">New Password</label>
                <div className="position-relative">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    autoComplete="new-password"
                    className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                    value={formData.newPassword}
                    onChange={handleChange}
                  />
                  <span
                    className="position-absolute top-50 translate-middle-y cursor-pointer"
                    style={{ right: "12px" }}
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    <Icon
                      icon={showNewPassword ? "mage:eye" : "mage:eye-off"}
                    />
                  </span>
                </div>
                {errors.newPassword && <div className="invalid-feedback d-block">{errors.newPassword}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label">Confirm New Password</label>
                <div className="position-relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    autoComplete="new-password"
                    className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  <span
                    className="position-absolute top-50 translate-middle-y cursor-pointer"
                    style={{ right: "12px" }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <Icon
                      icon={showConfirmPassword ? "mage:eye" : "mage:eye-off"}
                    />
                  </span>
                </div>
                {errors.confirmPassword && <div className="invalid-feedback d-block">{errors.confirmPassword}</div>}
              </div>

              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="logoutAllDevices"
                  name="logoutAllDevices"
                  checked={formData.logoutAllDevices}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="logoutAllDevices">
                  Logout from all devices
                </label>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Changing Password...' : 'Change Password'}
              </button>

            </form>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default ChangePassword;
